import { notNil } from "core/utils";
import { ParentRoot, unmountComponentFromRoot } from "core/utils/modals";
import { JSXElementConstructor } from "react";
import BSModal from "react-bootstrap/Modal";
import { createRoot } from "react-dom/client";
import "./modal.scss";

interface BaseModalProps {
	title?: string;
	parent?: ParentRoot;
	dialogClassName?: string;
	footer?: (close: VoidFunction) => React.ReactNode;
	onClosed?: VoidFunction;
}

export const renderElement = <T extends object>(root: HTMLElement, component: JSXElementConstructor<T>, props: T) => {
	const modalRoot = createRoot(root);
	const extendedProps: T & { parent: ParentRoot } = { ...props, parent: { element: root, modalRoot } };
	const Default: any = component;
	modalRoot.render(<Default {...extendedProps} />);
};

const Modal = (props: React.PropsWithChildren<BaseModalProps>) => {
	const close = () => {
		if (notNil(props.parent)) {
			unmountComponentFromRoot(props.parent);
			props.onClosed?.();
		}
	};

	return (
		<BSModal show={true} onHide={close} backdrop="static" dialogClassName={props.dialogClassName} keyboard={false}>
			<BSModal.Header closeButton><span>{props.title}</span></BSModal.Header>
			<BSModal.Body>
				{props.children}
			</BSModal.Body>
			<BSModal.Footer>
				{props.footer?.(close)}
			</BSModal.Footer>
		</BSModal>
	);
};

export default Modal;